// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import icons from "../../icons.config";
// import { useDispatch } from "react-redux";
// import { removeLikedItem,clearAll } from "../../store/likedItemsSlice";
// import { useNavigate } from "react-router-dom";

// const LikedItemsSlider = ({
//  likedItems, toggleSlider ,
// }) => {
//   const dispatch = useDispatch();
//   const navigate=useNavigate();

//   const handleRemove = (itemId) => {
//     dispatch(removeLikedItem({ id: itemId })); // Dispatch action
//   };
//     const handleClearAll = () => {
//     dispatch(clearAll()); // Add a corresponding case in your reducer
//   };
//   const goToShop=()=>{
//     navigate('/shop')
//     }
//   return (
//     <div className="fixed top-0 lg:right-0 -right-0 w-[90%] lg:w-1/3 h-full bg-tertiary shadow-lg z-50 transition-transform duration-300 ease-in-out">
//       {/* Close Button */}
//       <div className="p-4 flex justify-end items-end">
//         <FontAwesomeIcon
//           icon={faTimes}
//           className="cursor-pointer text-primary1 text-xl"
//           onClick={toggleSlider}
//         />
//       </div>

//       <div className="px-7">
//         {likedItems.length > 0 ? (
//           <>
//             {/* Favourites Heading and Clear All Button */}
//             <div className="flex items-center mb-4">
//               <h2 className="text-lg font-outfit text-hcolor">
//                 Favourites ({likedItems.length})
//               </h2>
//               <button
//                 className="text-sm text-red-500 font-medium underline ml-auto"
//                 onClick={handleClearAll}
//               >
//                 Clear All
//               </button>
//             </div>

//             {/* Liked Items List */}
//             {likedItems.map((item) => (
//               <div key={item.id} className="flex gap-4 mb-4 items-center">
//                 <img
//                   src={item.thumbnail}
//                   alt={item.title}
//                   className="w-[30%] lg:w-1/6 object-cover"
//                 />
//                 <div className="flex flex-col items-start flex-1">
//                   <p className="font-outfit font-light text-xl text-left">
//                     {item.title.toUpperCase()}
//                   </p>
//                   <p className="text-xs text-gray-500 text-left">
//                     ${item.price}
//                   </p>
//                 </div>
//                 <button
//                   className="text-red-500 text-sm"
//                   onClick={() => handleRemove(item.id)}
//                 >
//                   Delete
//                 </button>
//               </div>
//             ))}
//           </>
//         ) : (
//           <div className="flex flex-col items-center mt-40 space-y-4 transition-transform duration-300 ease-in-out">
//             <img src={icons.noItemLiked} alt="No liked items" className="w-20" />
//             <p className="text-center text-hcolor">No liked items yet!</p>
//             <button
//               onClick={() => goToShop()}
//               className="border-2 py-2 px-5 text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 bg-tertiary transition-all duration-800"
//             >
//               Explore
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default LikedItemsSlider;


import React,{useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { removeLikedItem, clearAll } from "../../store/likedItemsSlice";
import { useNavigate } from "react-router-dom";
import icons from "../../icons.config";
import { selectClickedItem } from "../../Providers/favouritesProvider";
import { addToCart } from "../../Providers/cartProvider";

const LikedItemsSlider = ({ likedItems, toggleSlider }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Get prices from Redux store
  const products = useSelector((state) => state.products?.items || []);

  const handleRemove = (itemId) => {
    dispatch(removeLikedItem({ id: itemId })); 
  };

  const handleClearAll = () => {
    dispatch(clearAll());
  };

  const goToShop = () => {
    navigate("/shop");
  };
   const clickedItem = useSelector(selectClickedItem);
   
     const [quantity, setQuantity] = useState(1);
     const [buttonTexts, setButtonTexts] = useState({}); // Object to track button text per item

  const handleAddToCart = (item) => {
    const selectedSize = item.selectedSize || "M/10"; // Default size
    
    if (item && item.discountedPrice) {
      dispatch(addToCart({ ...item, quantity, selectedSize }));
    } else {
      console.error("Item is missing price or is undefined!");
    }
  
    // Change button text only for this item
    setButtonTexts((prev) => ({ ...prev, [item.id]: "ADDED TO CART!" }));
  
    // Reset text after 3 seconds for this specific item
    setTimeout(() => {
      setButtonTexts((prev) => ({ ...prev, [item.id]: "ADD TO CART" }));
    }, 3000);
  };
  
  

  return (
    <div className="fixed top-0 left-0 lg:-left-0 w-[90%] lg:w-1/3 h-full bg-tertiary shadow-lg z-50 transition-transform duration-300 ease-in-out overflow-y-scroll">
      {/* Close Button */}
      <div className="p-4 flex justify-end items-end">
        <FontAwesomeIcon
          icon={faTimes}
          className="cursor-pointer text-primary1 text-xl"
          onClick={toggleSlider}
        />
      </div>

      <div className="px-7">
        {likedItems.length > 0 ? (
          <>
            {/* Favourites Heading and Clear All Button */}
            <div className="flex items-center mb-4">
              <h2 className="text-lg font-outfit text-hcolor">
                Favourites ({likedItems.length})
              </h2>
              <button
                className="text-sm text-red-500 font-medium underline ml-auto"
                onClick={handleClearAll}
              >
                Clear All
              </button>
            </div>

            {/* Liked Items List */}
            {likedItems.map((item) => {
              const product = products.find((p) => p.id === item.id);
              const price = product ? product.discountedPrice : "N/A";

              return (
                <div key={item.id} className="relative flex gap-4 mb-4 ">
                  {/* Image Section with Remove Icon */}
                  <div className="relative w-[30%] md:w-[17%] lg:w-[20%]">
                    <img src={item.thumbnail} alt={item.title} className="w-full object-cover" />
                    <button
                      className="absolute -top-2 -right-2"
                      onClick={() => handleRemove(item.id)}
                    >
                      <img src={icons.removeLikedItem} alt="remove item" />
                    </button>
                  </div>

                  {/* Product Details */}
                                 {/* Details */}
                                 <div className="flex flex-col flex-1">
                                   <p className="font-outfit font-light text-base lg:text-2xl">{item.title}</p>
                                   <p className="font-outfit text-xs lg:text-sm font-normal text-hcolor">material: {item.material || "unknown"}</p>
                                   <p className="text-xs lg:text-sm text-gray-500">Size: {item.selectedSize||"M/10"}</p>
                                   <button
  className={`py-2 border text-hcolor bg-tertiary md:mt-6 w-full  text-sm 
    ${buttonTexts[item.id] && buttonTexts[item.id] !== "ADD TO CART" ? "lg:w-[50%] px-1 whitespace-nowrap" : "lg:w-[47%]"}`}
  onClick={() => handleAddToCart(item)}
>
  {buttonTexts[item.id] || "ADD TO CART"}
</button>



                                 </div>
                                 {/* Pricing and Stock */}
                                 <div className="text-right">
                                   <p className="text-lg font-bold text-primary">
                                     Rs.{item.discountedPrice}
                                   </p>
                                   <p className="text-sm text-gray-500 line-through">
                                     Rs.{item.price}
                                   </p>
                                   <p className={`text-sm ${item.inStock ? "text-green-500" : "text-red-500"}`}>
                                     {item.inStock ? "In Stock" : "Out of Stock"}
                                   </p>
                                 </div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="flex flex-col items-center mt-40 space-y-4">
            <img src={icons.noItemLiked} alt="No liked items" className="w-20" />
            <p className="text-center text-hcolor">No liked items yet!</p>
            <button
              onClick={goToShop}
              className="border-2 py-2 px-5 text-hcolor font-outfit font-medium hover:bg-hcolor hover:text-primary2 bg-tertiary transition-all duration-800"
            >
              Explore
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default LikedItemsSlider;
